<template>
  <div class="preciosV">
    <Menu />
    <Submenu/>

    <h3 class="text-center my-5">Nuestros Precios</h3>

    <section class="pricing py-5">
      <div class="container">

        <div class="row" v-if="sessionId !== null">
          <stripe-checkout
            ref="sessionRef"
            :pk="pk"
            :session-id="sessionId"
          >
            <template slot="checkout-button">
              <button
                @click="$refs.sessionRef.redirectToCheckout()"
                color="#42b883"
                large
                dark
              >Subscribe</button>
            </template>
          </stripe-checkout>
        </div>

        <div class="row" v-if="sessionId === null">

          <!-- Free Tier -->
          <div class="col-lg-4" v-for="(item, index) in products" :key="item.id">
            <div class="card mb-5 mb-lg-0">
              <div class="card-body">
                <h5 class="card-title text-muted text-uppercase text-center">{{item.name}}</h5>
                <h6 class="card-price text-center">${{item.price}}<span class="period">/month</span></h6>
                <hr>
                <ul class="fa-ul">
                  <li><span class="color-checkm"><font-icon icon="check-circle"></font-icon></span><strong> {{item.desc}}</strong></li>

                </ul>
                <button type='button' class='btn btn-block btn-primary text-uppercase'  v-on:click="buyProduct(index)" >Buy</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

  </div>
</template>
<script>
    import Menu from '@/components/Menu'
    import Submenu from '@/components/Submenu'
    import {StripeCheckout } from 'vue-stripe-checkout';
    export default {
        components:{Menu,Submenu, StripeCheckout},
        data () {
            return {
                url: urlGlobal,
                pk: localStorage.pk,
                loading: false,
                token: null,
                charge: null,
                sessionId:null,
                products: [
                    {
                        id: 1,
                        product_id: 'prod_IXHvbaYMR7D0Vc',
                        name: 'pear',
                        desc: "sweat pear",
                        price: 15,
                        price_id: 'price_1HwDLKHqAl9De6QH1pxZStsw'
                    },
                    {
                        id: 2,
                        product_id: 'prod_IXHuqikqkHIHAm',
                        name: 'apple2',
                        desc: "fresh apple",
                        price: 300,
                        price_id: 'price_1HwDSuHqAl9De6QHuvRABaX3'
                    },
                ],
            }
        },
        methods:{
            buyProduct (index) {
                const send_data = {
                    name: this.products[index].name,
                    price_id: this.products[index].price_id,
                    quantity: 1
                }
                this.axios.post(this.url + `checkout.php`, send_data)
                    .then(response => {
                        //console.log('response:...', response);
                        if (response.data.sessionId) {
                            // alert(response.data.sessionId)
                            this.sessionId = response.data.sessionId;
                            //console.log(this.sessionId);
                        }
                    })
                    .catch(e => {
                        //console.log('errors:...', e);
                    })
            }
        }
    }

</script>


<style lang="">
  @import url('https://fonts.googleapis.com/css2?family=Ubuntu&display=swap');
  .preciosV{
    font-family: 'Ubuntu', sans-serif;
  }
  section.pricing {
    background: #007bff;
    background: linear-gradient(to right, #0062E6, #33AEFF);
  }

  .pricing .card {
    border: none;
    border-radius: 1rem;
    transition: all 0.2s;
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
  }

  .pricing hr {
    margin: 1.5rem 0;
  }

  .pricing .card-title {
    margin: 0.5rem 0;
    font-size: 0.9rem;
    letter-spacing: .1rem;
    font-weight: bold;
  }

  .pricing .card-price {
    font-size: 3rem;
    margin: 0;
  }

  .pricing .card-price .period {
    font-size: 0.8rem;
  }

  .pricing ul li {
    margin-bottom: 1rem;
  }

  .pricing .text-muted {
    opacity: 0.7;
  }

  .pricing .btn {
    font-size: 80%;
    border-radius: 5rem;
    letter-spacing: .1rem;
    font-weight: bold;
    padding: 1rem;
    opacity: 0.7;
    transition: all 0.2s;
  }
  .color-check{
    color: #4da3ff;
  }
  .color-checkm{
    color: #00d58c;
  }
  .color-checkbm{
    background-color: #00d58c !important;
    color: #fff !important;
  }
  .color-checkbm:hover{
    color: #fff !important;
  }
  /* Hover Effects on Card */

  @media (min-width: 992px) {
    .pricing .card:hover {
      margin-top: -.25rem;
      margin-bottom: .25rem;
      box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.3);
    }
    .pricing .card:hover .btn {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Payment2.vue